module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/long-metrage.json
// module id = 606
// module chunks = 137735932733995